export default __webpack_public_path__ + "static/6-ff572c4965a120a91013d5a88e8133e4.jpg";